import * as Papa from "papaparse";

export function setToTwoDecimalPlaces(value: string): string {
  return parseFloat(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatBytes(bytes) {
  return bytes / 1024 ** 2;
}

export function isNullOrEmpty(value: string | null | undefined): boolean {
  return value === null || value === undefined || value.trim().length === 0;
}

export function convertToCSV(convertToCsvArray, fileName) {
  const csv = Papa.unparse(convertToCsvArray);
  const blob = new Blob([csv], { type: "text/csv" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

export function deactivateInputFieldOnEnter(fieldName: string) {
  const inputField = document.getElementById(fieldName) as HTMLInputElement;
  if (inputField) {
    inputField.blur();
  }
}

export function capitalizeEachWord(input: string): string {
  return input
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function removeWhiteSpaces(input: string): string {
  return input.replace(/\s+/g, "");
}

export function openInNewTab(url) {
  window.open(url, "_blank");
}

export function toOrdinalNumber(value: number): string {
  if (isNaN(value) || value === null) {
    return "";
  }

  const s = ["th", "st", "nd", "rd"];
  const v = value % 100;
  return value + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function hexToString(hex: string): string {
  hex = hex.replace(/^0x/, "");

  let str = "";
  for (let i = 0; i < hex.length; i += 2) {
    const code = parseInt(hex.substr(i, 2), 16);
    str += String.fromCharCode(code);
  }
  return str;
}

export function stringToHex(str: string): string {
  let hex = "";
  for (let i = 0; i < str.length; i++) {
    hex += str.charCodeAt(i).toString(16).padStart(2, "0");
  }
  return hex;
}

export function modifySvgColor(color: string, id: string) {
  const svgObject = document.getElementById(id) as HTMLObjectElement;
  svgObject.onload = () => {
    const svgDoc = svgObject.contentDocument;
    const paths = svgDoc.querySelectorAll("path");

    paths.forEach((path) => {
      path.setAttribute("fill", color);
    });
  };
}

export function checkAndFormatDateStringToISOString(
  dateString: string
): string {
  const slashPattern = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  let returnValue = dateString;

  if (slashPattern.test(dateString)) {
    const [mm, dd, yyyy] = dateString.split("/");
    let month = mm.length == 1 ? `0${mm}` : mm;
    let day = dd.length == 1 ? `0${dd}` : dd;
    returnValue = `${yyyy}-${month}-${day}`;
  }

  return returnValue;
}

export function maskEmail(email: string) {
  const username = email.split("@")[0];
  const username_length = username.length;
  const username_char_array = username.split("");
  let maskedEmail = "";
  if (username_length <= 4) {
    maskedEmail += username_char_array[0];
    for (let i = 1; i < username_length; i++) {
      maskedEmail += "*";
    }
  } else {
    maskedEmail += username_char_array[0];
    maskedEmail += username_char_array[1];
    for (let i = 2; i < username_length; i++) {
      maskedEmail += "*";
    }
  }
  return maskedEmail + `@${email.split("@")[1]}`;
}

export function scrollToTop() {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

export function openModal(modal, size) {
  this.modalService.open(modal, {
    size: size,
    backdrop: "static",
    keyboard: false,
  });
}

export function isBase64(str): boolean {
  if (!str) {
    return false;
  }
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;
  return base64Regex.test(str);
}

export function convertValuesToUpperCase(obj: any): any {
  let outputObj: any = obj;
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "string") {
      obj[key] = outputObj[key].toUpperCase();
    }
  });
  return outputObj;
}

export function concatenateFullName(
  firstName: any,
  middleName: any,
  lastName: any,
  suffixName: any
): string {
  const hasMiddleNoSuffix = middleName && !suffixName;
  const noMiddleHasSuffix = !middleName && suffixName;
  const noMiddleNoSuffix = !middleName && !suffixName;

  if (hasMiddleNoSuffix) {
    return [firstName, middleName, lastName].join(" ");
  } else if (noMiddleHasSuffix) {
    return [firstName, lastName, suffixName].join(" ");
  } else if (noMiddleNoSuffix) {
    return [firstName, lastName].join(" ");
  }

  return [firstName, middleName, lastName, suffixName].join(" ");
}

export function getUserOnSessionStorage(
  request_data:
    | "all"
    | "role"
    | "memberCode"
    | "isPrivileged"
    | "applicantNumber"
    | "id"
    | "eFundUserAccess"
    | undefined
) {
  let user;
  user = sessionStorage.getItem("currentUser");
  if (user) {
    user = JSON.parse(user);
    if (request_data) {
      if (request_data == "role") {
        user = user.roles[0];
      } else if (request_data == "memberCode") {
        user = user.memberCode;
      } else if (request_data == "isPrivileged") {
        user = user.isPrivileged;
      } else if (request_data == "id") {
        user = user.id;
      }else if (request_data == "applicantNumber") {
        user = user.userName;
      }else if (request_data == "eFundUserAccess") {
        user = user.eFundUserAccess;
      }
    }
  }
  return user;
}

export function convertToSpaceCase(value: string): string {
  if (!value) {
    return "";
  }

  const spacedValue = value.replace(/([A-Z])/g, " $1").trim();

  return spacedValue.replace(/\bAnd\b/g, "and");
}

export function getSucceedingYears(startYear: number): number[] {    
    const currentYear = new Date().getFullYear();

    return Array.from(
      { length: currentYear - startYear + 1 },
      (_, index) => startYear + index
    );
  }


export function isISODateString(value: string): boolean {
  const date = new Date(value);

  return (
    !isNaN(date.getTime()) &&
    date.toISOString().split("T")[0] === value
  );
}